module.exports = __webpack_public_path__ + "img/vip-img6.75c92a46.png";